import { logingout,userLogin } from '@/api/user'
import router from '@/router'
import Vue from 'vue'
import { Message } from 'element-ui'

const state = {
	userid: '',
	username: '',
	authorization:'', //user_login_token
	userRole:'',
}

const mutations = {
  SET_USERID: (state, userid) => {
    state.userid = userid
  },
  SET_USERNAME: (state, username) => {
    state.username = username
  },
  SET_TYPETOKEN: (state, authorization) => {
    state.authorization = authorization
  },
}

const actions = {
	//user login
	userLogin({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
			
			userLogin(userInfo).then(response => {
        		const { Authorization } = response.data;
				commit('SET_TYPETOKEN',Authorization)
				console.log(userInfo.username)
				localStorage.setItem('Authorization', Authorization)
				localStorage.setItem('username', userInfo.username)
                resolve()
            }).catch(error => {
                console.log(error)
                reject(false)
            })
        })
	},

  
  // 退出账号
  logingout({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
		logingout().then(() => {
		// 清楚个人信息
			commit('SET_TYPETOKEN','')
			localStorage.removeItem('Authorization');
			resolve()
		}).catch(error => {
			console.log(error)
			reject(false)
		})
		
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
